<template>
    <div class="ua-flag-home">
      <div class="header">
        <img v-if="match.backgroundImage2" :src="imgView(match.backgroundImage2)" alt="" />
      </div>
      <div class="tabs">
        <div
          class="tab"
          v-for="tab in tabs"
          :key="tab.path"
          @click="goList(tab.path)"
        >
          <img :src="tab.icon" />
          <div class="name">{{ tab.name }}</div>
        </div>
      </div>
      <div class="title" v-if="status.length > 0">
        <div class="title-name">赛程实况</div>
        <div class="more" @click="goList('schedule')">MORE <van-icon name="play" /></div>
      </div>
      <div class="content" v-if="status.length > 0 || teamList.length > 0">
        <div class="games" v-if="status.length > 0">
          <div
            class="game"
            v-for="item in status"
            :key="item.id"
            @click="ateToPage(item)"
          >
            <div class="team">
              <div class="icon">
                <img :src="filterImage(item.homeTeam.badge, 30, 30)" />
              </div>
              <div class="name overflow-text">{{ item.homeTeam.name }}</div>
              <div class="score">
                <span v-if="item.homeScore !== -1">{{ item.homeScore }}</span>
              </div>
            </div>
            <div class="line"></div>
            <div class="team">
              <div class="icon">
                <img :src="filterImage(item.awayTeam.badge, 30, 30)" />
              </div>
              <div class="name overflow-text">{{ item.awayTeam.name }}</div>
              <div class="score">
                <span v-if="item.awayScore !== -1">{{ item.awayScore }}</span>
              </div>
            </div>
            <div class="bottom">
              <div class="state" :style="{ color: item.liveStatus.statusLabel === '视频录像' ? 'rgb(54, 154, 212)' : (item.color || '') }">
                {{ item.liveStatus.statusLabel }}
              </div>
              <div class="time">{{ filterDate(item.beginDate) }} {{ item.roundDescription }}</div>
            </div>
          </div>
        </div>
        <div class="list" v-if="teamList.length > 0">
          <div
            class="item"
            v-for="item in teamList"
            :key="item.id"
            @click="goTeamRoster(item)"
          >
            <div class="icon">
              <img :src="filterImage(item.badge, 46, 46)" />
            </div>
            <div class="info">
              <div class="name overflow-text">{{ item.name }}</div>
              <div class="text overflow-text">{{ item.location }}</div>
            </div>
            <div class="right">
              <div class="label">参赛名单</div>
              <div class="time" :class="{ muted: item.playerCount === 0 }">
                <template v-if="item.playerCount !== 0">{{ item.playerCount }}</template>
                <template v-else>未公布</template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { getBMMatchDetail } from '@/api/match'
import { QNImageUtil } from '@/utils'
import Moment from 'moment'
import { goNewVersionPage } from '@/utils/index'
import { Toast } from 'vant'
import Vue from 'vue'

Vue.use(Toast)

export default {
  data() {
    return {
      matchId: null,
      match: {},
      status: [],
      teamList: [],
      showPlayerList: 0,
      tabs: [
        {
          name: '积分榜',
          icon: 'https://images.snsports.cn/FhoygNwjSr9tXW8qHeJ4lmVM1DWq',
          path: 'standings'
        },
        {
          name: '赛程榜',
          icon: 'https://images.snsports.cn/Fq1Ir0kPTpP3PuFs_9T-PyYa2jmx',
          path: 'schedule'
        },
        {
          name: '球员榜',
          icon: 'https://images.snsports.cn/Fp-shn3Bx02cbO_ojmv1MzwF4c-H',
          path: 'player-list'
        },
        {
          name: '球队数据',
          icon: 'https://images.snsports.cn/Fh5X8RuM8Vf_eFY2SdS-_Tjtjos8',
          path: 'team-data'
        }
      ]
    }
  },
  created() {
    this.matchId = this.$route.query.matchId
    if (!this.matchId) {
      Toast('缺少赛事参数 matchId')
      return
    }
    this.getBMMatchDetail()
  },
  methods: {
    getBMMatchDetail() {
      getBMMatchDetail({ matchId: this.matchId }).then(res => {
        const data = res.data
        const unionMatch = res.data.unionMatch
        this.showPlayerList = unionMatch.showPlayerList
        if (data.roundGames) {
          this.status = data.roundGames.games.map(item => {
            if (item.liveStatus.status === -3 || item.liveStatus.status === 0 || (item.liveStatus.status === -1 && item.liveStatus.statusLabel === '即将直播')) {
              item.color = '#CF2F30'
            } else if ((item.liveStatus.status === -1 && item.liveStatus.statusLabel === '比赛进行中') || item.liveStatus.status === 1) {
              item.color = '#CF2F30'
            } else if (item.liveStatus.status === 2) {
              item.color = '#369AD4'
            }
            return item
          })
        } else {
          this.status = []
        }
        this.match = data.match || {}
        const nameParts = (this.match.chineseName || '').split('_')
        const shareObj = {
          title: (nameParts[0] || '') + this.getPromotion(unionMatch.beginDate, unionMatch.endDate),
          abstract: nameParts[1] || '',
          image: QNImageUtil.imageView(this.match.icon),
          link: window.location.href
        }
        this.wxShare(shareObj)
        this.teamList = data.teamList || []
      })
    },
    getPromotion(createDate, endDate) {
      const startTime = new Date(createDate)
      const endTime = new Date(endDate)
      const currentTime = new Date()
      if (currentTime < startTime) {
        return '-敬请期待'
      } else if (currentTime >= startTime && currentTime <= endTime) {
        return '-激战正酣'
      }
      return '-完美闭幕'
    },
    goList(path) {
      if (!this.matchId) return
      this.$router.push({ path: `/ua-flag/match/${this.matchId}/${path}`})
    },
    ateToPage(game) {
      if (game.liveStatus && (game.liveStatus.status === 1 || game.liveStatus.status === 2)) {
        goNewVersionPage({ path: 'gameSummary', gameId: game.id })
      } else {
        this.$router.push({ name: 'UaFlagEventDetail', query: { gameId: game.id } })
      }
    },
    filterDate(date) {
      return Moment(date).format('MM/DD')
    },
    filterImage(img, w, h, mode) {
      return QNImageUtil.imageView(img, parseInt(2 * w, 10), parseInt(2 * h, 10), mode)
    },
    imgView(img) {
      return QNImageUtil.imageView(img)
    },
    goTeamRoster(item) {
      if (this.showPlayerList === -1) {
        Toast('组委会暂未开放名单查看功能')
        return
      }
      if (item.playerCount === 0) {
        Toast('参赛名单未公布')
        return
      }
      this.$router.push({ name: 'UaFlagTeamPlayer', query: { matchId: this.matchId, teamId: item.id } })
    }
  }
}
</script>

<style scoped lang="scss">
.overflow-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ua-flag-home{
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  background: linear-gradient(180deg, #DC0019 2%, #282831 100%);
  display: flex;
  flex-direction: column;
  .header{
    width: 343px;
    height: 188px;
    min-height: 188px;
    border-radius: 10px;
    overflow: hidden;
    margin: 0 auto;
    background-color: #000;
    margin-top: 12px;
    img{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .tabs{
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 22px;
    .tab{
      text-align: center;
      font-size: 0;
      color: #fff;
      cursor: pointer;
      .name{
        font-size: 12px;
      }
    }
    img{
      width: 28px;
      height: 28px;
      margin-bottom: 6px;
    }
  }
  .title{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 18px;
    padding-right: 12px;
    margin-top: 30px;
    color: #fff;
    .title-name{
      font-size: 20px;
      font-weight: bold;
      position: relative;
      z-index: 2;
      &::before{
        content: '';
        position: absolute;
        bottom: 2%;
        left: -6px;
        transform: skewX(-25deg);
        width: 100%;
        height: 6px;
        background: linear-gradient(90deg, #FF682C 0%, rgba(129, 1, 15, 0) 95%);
        z-index: -1;
      }
    }
    .more{
      font-size: 13px;
      cursor: pointer;
    }
  }
  .content{
    flex: 1;
    background-color: #000;
    margin-top: 30px;
    position: relative;
    // padding: 0 16px;
    box-sizing: border-box;
    padding-bottom: 22px;
    &::after{
      content: '';
      position: absolute;
      width: 100%;
      height: 18px;
      left: 0px;
      top: -18px;
      box-sizing: border-box;
      border-radius: 22px 22px 0px 0px;
      background: #000000;
    }
    .games{
      padding: 0 16px;
      display: flex;
      gap: 15px;
      box-sizing: border-box;
      overflow-x: auto;
      &::-webkit-scrollbar {
        display: none;
      }
      .game{
        min-width: 245px;
        width: 245px;
        height: 140px;
        border-radius: 8px;
        background: rgba(255, 255, 255, 0.1);
        padding: 15px;
        padding-bottom: 10px;
        color: #fff;
        box-sizing: border-box;
        flex-shrink: 0;
        cursor: pointer;
        .team{
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 30px;
          img{
            width: 30px;
            height: 30px;
            border-radius: 50%;
          }
          .name{
            flex: 1;
            margin-left: 12px;
            font-size: 14px;
            min-width: 0;
          }
          .score{
            font-size: 16px;
            font-weight: 600;
          }
        }
        .line{
          height: 1px;
          background-color: rgba(216, 216, 216, 0.1);
          margin: 10px 0;
        }
        .bottom{
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #B4B4BF;
          font-size: 12px;
          margin-top: 16px;
          .time{
            max-width: 50%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
    .list{
      padding: 0 16px;
      .item{
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 22px;
        box-sizing: border-box;
        border-radius: 8px;
        background: rgba(255, 255, 255, 0.1);
        margin-top: 12px;
        padding: 20px 12px 16px 16px;
        cursor: pointer;
        .icon{
          width: 46px;
          height: 46px;
          overflow: hidden;
          flex-shrink: 0;
          img{
            width: 100%;
            height: 100%;
          }
        }
        .info{
          flex: 1;
          min-width: 0;
          .name{
            font-size: 18px;
            font-weight: 500;
            color: #fff;
          }
          .text{
            font-size: 14px;
            color: #B4B4BF;
            margin-top: 6px;
          }
        }
        .right{
          text-align: right;
          flex-shrink: 0;
          .label{
            font-size: 14px;
            color: #fff;
          }
          .time{
            font-size: 16px;
            font-weight: 500;
            color: #FF682C;
            margin-top: 6px;
            &.muted{
              color: #9B9B9B;
              font-weight: 400;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
</style>
